// @flow
import { getCreator, postCreator } from '../../../../http';
import environment from '../../../../environment';

export const endpoints = Object.freeze({
  SET_TRACKING_NUMBER: `${environment.apiUrl}/purchase/:orderId/:itemNumber/set-tracking-number`,
});

export const postSetTrackingNumberApi = postCreator(fetch, endpoints.SET_TRACKING_NUMBER);



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/courier-flow/api.js